(() => {
  'use strict';
  const config = document.querySelector('[data-flo-cart-config]');
  if (!config) return;
  const settings = JSON.parse(config.textContent), rules = window.MASetRules;
  const products = new Map(settings.products.map(p => [String(p.id), p]));
  const variants = new Map(settings.products.flatMap(p => p.variants.map(v => [String(v.id), {product:p, variant:v}])));
  const dialog = document.querySelector('[data-flo-cart-dialog]'), message = dialog.querySelector('[data-flo-cart-message]');
  const details = dialog.querySelector('[data-flo-cart-lines]'), approved = new WeakSet();
  const catalogReady=window.MACatalog.response(settings.catalog).then(r=>{if(!r.ok)throw Error('catalog');return r.json();}).then(all=>{for(const p of all){if(p.eligible){products.set(String(p.id),p);for(const v of p.variants)variants.set(String(v.id),{product:p,variant:v});}else {products.delete(String(p.id));for(const v of p.variants)variants.delete(String(v.id));}}return true;}).catch(()=>false);
  let busy = false;
  const money = n => new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(n / 100);
  function state(cart) {return rules.cartState(cart.items, products);}
  async function getCart() {const response = await fetch(settings.root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'}); if (!response.ok) throw Error('cart'); return response.json();}
  function show(text) {message.textContent = text; details.replaceChildren(); if (!dialog.open) dialog.showModal();}
  async function checkout() {
    if (busy) return; busy = true;
    try {
      if(!await catalogReady)throw Error("catalog");const cart = await getCart(), result = state(cart);
      if (result.count > 0 && result.flow.some(line => line.final_line_price !== 1250 * line.quantity)) {show(settings.ui.preview.replace('{total}', money(result.count * 1250))); return;}
      location.assign(settings.root + 'checkout');
    } catch {show(settings.ui.error);} finally {busy = false;}
  }
  document.addEventListener('click', e => {const button = e.target.closest('[name="checkout"],a[href="/checkout"],a[href$="/checkout"]'); if (!button) return; e.preventDefault(); e.stopImmediatePropagation(); checkout();}, true);
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (form.matches('form[action$="/cart"]') && e.submitter?.name === 'checkout') {e.preventDefault(); e.stopImmediatePropagation(); checkout(); return;}
    if (!form.matches('form[action*="/cart/add"]')) return;
    const data = new FormData(form), selected = variants.get(String(data.get('id')));
    if (!selected) return;
    if (approved.has(form)) {approved.delete(form); return;}
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return;
    const submitter = e.submitter;
    busy = true;
    try {
      const cart = await getCart(), next = {product_id:selected.product.id, variant_id:selected.variant.id, quantity:1};
      approved.add(form); busy = false; form.requestSubmit(submitter);
    } catch {show(settings.ui.error);} finally {busy = false;}
  }, true);
  dialog.querySelector('[data-flo-cart-close]').addEventListener('click', () => dialog.close());
})();
